import { useQuery } from '@tanstack/react-query';
import { Panel, FlexCell, Spinner } from '@epam/promo';
import { getAdmins } from 'api/admin.service';
import { useUserStore } from 'store/user.store';
import { PermissionCard, PermissionForm } from 'components/permissions';
import css from './PermissionPage.module.scss';

export const PermissionPage = () => {
  const currentUser = useUserStore((state) => state.user);
  const { isLoading, data: admins } = useQuery(['admins'], getAdmins);

  if (isLoading) {
    return <Spinner color="blue" />;
  }

  if (!admins || admins.length === 0) {
    return (
      <Panel shadow background="white" cx={css.page__panel}>
        <FlexCell>
          <PermissionForm />
        </FlexCell>
        <FlexCell cx={css['page__gutter-top']}>
          <PermissionCard user={currentUser} />
        </FlexCell>
      </Panel>
    );
  }

  return (
    <Panel
      shadow
      background="white"
      cx={
        admins.length < 10
          ? css.page__panel
          : `${css.page__panel} ${css['page__no-gutter']}`
      }>
      <FlexCell>
        <PermissionForm />
      </FlexCell>
      <FlexCell cx={css['page__gutter-top']}>
        {[currentUser, ...admins].map((admin) => (
          <PermissionCard key={admin.id} user={admin} />
        ))}
      </FlexCell>
    </Panel>
  );
};
